import type { ApiProblemDetails } from "Infrastructure/Api/Api";
import { Resources } from "Translations/Resources";

const RESOURCES = Resources.Roles.AddRole;

/**
 * Picks the toast message for a failed add-role request. The backend keys its precondition
 * failures by a stable name (RoleAdditionGuard), so the KYC gate can tell the user to finish
 * their customer registration first instead of reporting a generic failure.
 */
export const getAddRoleErrorResource = (error: unknown) => {
  const errors = (error as { data?: ApiProblemDetails } | null)?.data?.errors;

  if (errors?.FullMooneRequired) {
    return RESOURCES.KycRequired;
  }

  if (errors?.BackOfficeIdentity) {
    return RESOURCES.BackOfficeAccount;
  }

  return RESOURCES.Form.Error;
};
